module.exports = __webpack_public_path__ + "img/20190704162920YY截图20190704013404.f12c4509.png";